import { CardShowYou } from "../components/WeShowYou"
import benefit1 from '../../../assets/img/benefits/benefit1.jpg'
import benefit2 from '../../../assets/img/benefits/benefit2.jpg'
import benefit3 from '../../../assets/img/benefits/benefit3.jpg'
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination } from "swiper"

export const WeShowYou = () => {
    return (
        <div>
            <h2 className="w-[95%] mx-auto md:w-full flex justify-center items-center primaryFont text-[#3533FF] text-3xl md:text-[2.5rem] font-bold">
                EN LOKL TE MOSTRAMOS COMO!
                <svg className="hidden md:flex ml-2" width="25" height="25" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25 13C25 5.83188 19.3924 -2.45115e-07 12.5 -5.46392e-07C5.60757 -8.4767e-07 1.65243e-06 5.83187 1.3391e-06 13C1.02577e-06 20.1681 5.60757 26 12.5 26C19.3924 26 25 20.1681 25 13ZM11.9411 17.6731L7.78606 10.52C7.72699 10.4175 7.69522 10.3004 7.69399 10.1809C7.69277 10.0614 7.72213 9.94371 7.77908 9.83989C7.83602 9.73607 7.9185 9.64988 8.01805 9.59015C8.1176 9.53042 8.23063 9.49931 8.34555 9.5L16.6544 9.5C16.7694 9.49931 16.8824 9.53042 16.982 9.59015C17.0815 9.64988 17.164 9.73607 17.2209 9.83989C17.2779 9.94371 17.3072 10.0614 17.306 10.1809C17.3048 10.3004 17.273 10.4175 17.2139 10.52L13.0589 17.6731C13.0005 17.7728 12.9184 17.8552 12.8205 17.9124C12.7226 17.9696 12.6123 17.9996 12.5 17.9996C12.3877 17.9996 12.2774 17.9696 12.1795 17.9124C12.0816 17.8552 11.9995 17.7728 11.9411 17.6731Z" fill="#3533FF" />
                </svg>
            </h2>
            <div className="mt-16">
                <Swiper
                    slidesPerView={1}
                    spaceBetween={10}
                    pagination={true}
                    modules={[Pagination]}
                    className="mySwiper"
                    breakpoints={{
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 50,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 100,
                        }
                    }}
                >
                    <SwiperSlide>
                        <CardShowYou
                            key={1}
                            src={benefit1}
                            title='TENER BENEFICIOS Y DESCUENTOS ÚNICOS'
                            text="Ten desde 10% de descuento en servicios de los proyectos a noches gratuitas..."
                            textButton="Descubre más beneficios"
                            link="/blog/beneficios-inversion-propiedades-turisicas"
                        />
                    </SwiperSlide>
                    <SwiperSlide>
                        <CardShowYou
                            key={2}
                            src={benefit2}
                            title='INVIERTIR DE MANERA COLABORATIVA'
                            text="Creamos una comunidad que le apasiona crecer con eventos, network y más!"
                            textButton="Sé parte de la comunidad"
                            link="https://www.instagram.com/reel/CuVhJbPAa_2/"
                        />
                    </SwiperSlide>
                    <SwiperSlide>
                        <CardShowYou
                            key={3}
                            src={benefit3}
                            title='PARTICIPAR EN PROYECTOS POSITIVOS'
                            text="Invierte en el futuro que quieres crear con proyectos con impacto positivo"
                            textButton="Invierte con impacto"
                            link="/blog/impacto-social-inversiones-inmobiliarias"
                        />
                    </SwiperSlide>
                </Swiper>

            </div>
        </div>
    )
}
